import { t } from 'i18next'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useBasePath } from '../../customHooks/useBasePath';

const SidebarOption = ({ sidebarOption, closeSidebar }) => {

    const navigate = useNavigate();
    const actualPath = useBasePath();

    const handleNavigate = (redirection) => {
        navigate(redirection);
        closeSidebar();
    }

    const isActive = (path) => path === actualPath;

    return (
        <div
            type="button"
            {...(sidebarOption.onClick) && { onClick: sidebarOption.onClick }}
            {...(sidebarOption.redirection) && { onClick: () => handleNavigate(sidebarOption.redirection) }}
            className={`d-flex align-items-center opt-side ${isActive(sidebarOption.onScreen) ? 'active' : ''}`}
        >
            <img
                className={`me-2`}
                src={require(`../../assets/icons/${sidebarOption.icon}`)}
                alt={`${t(sidebarOption.key)} icon`}
            />
            <p className='m-0'>{t(sidebarOption.key)}</p>
        </div>

    )
}

export default SidebarOption